import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject, throwError } from "rxjs";
import { map, retry, catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  public SERVER_BASEURL = "http://localhost:5001/";
   //public SERVER_BASEURL = "https://nimidode.nimiquestionbank.in/";

  constructor(private httpClient: HttpClient) { }

  showJcmarquee() {
    return this.httpClient.get(this.SERVER_BASEURL + "showJcmarquee").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  showJcnotication() {
    return this.httpClient.get(this.SERVER_BASEURL + "showJcnotication").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showFileVacncy() {
    return this.httpClient.get(this.SERVER_BASEURL + "showFileVacncy").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  otr(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "otr/" , args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  otrPersonalForm(args: any){
    return this.httpClient.post(this.SERVER_BASEURL + "otrPersonalForm/" , args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  fileStore(args: any){

    return this.httpClient.post(this.SERVER_BASEURL + "fileStore/" , args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  liststate(){
    return this.httpClient.get(this.SERVER_BASEURL + "liststate/").pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  enterState(args:any){
    return this.httpClient.post(this.SERVER_BASEURL + 'enterState/', args).pipe(
      map((data) =>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  uploadTest(args:any){
    return this.httpClient.post(this.SERVER_BASEURL + 'uploadfile/', args).pipe(
      map((data) =>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  uploadfile(formData:any){
    return this.httpClient.post(this.SERVER_BASEURL + 'uploadfile/', formData).pipe(
      map((data) =>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  upt_reg_form(formData:any){
    return this.httpClient.post(this.SERVER_BASEURL + 'upt_reg_form/', formData).pipe(
      map((data) =>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  regFormApplyCheck(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'regFormApplyCheck/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }
  regFormApply(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'regFormApply/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  emailCheck(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'emailCheck/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  mobileCheck(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'mobileCheck/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  loginCheck(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'loginCheck/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listDashboard(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'listDashboard/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listDashboardEdu(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'listDashboardEdu/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listDashboardProf(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'listDashboardProf/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listDashboardWrkexp(args:any){
    return this.httpClient.post(this.SERVER_BASEURL+ 'listDashboardWrkexp/', args).pipe(
      map((data)=>{
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listCoursespl(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'listCoursespl/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listjcvacancytitle(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'listjcvacancytitle/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  listjcvacancydesc(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'listjcvacancydesc/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }
  

  handleError(error:any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = `${error.error.message}`;
    } else {
      // server-side error
      //errorMessage = `${error.status} <br /> Message: ${error.message}`;
      errorMessage = `Server Error<br /> Message: ${error.message}`;
    }

    return throwError(errorMessage);
  }


   public get(){
     return this.httpClient.get<any>(this.SERVER_BASEURL);
   }

//     uploadFile(args:any,value1:any,value2:any){
//    const headers = new HttpHeaders({
//     // Authorization: `Bearer ${access_token}`
//   });
//   const endpoint = this.SERVER_BASEURL+'uploadfile/';
//     const formData: FormData = new FormData();
//     formData.append('args',args);
//     formData.append('value1',value1);
//     formData.append('value2',value2);



//   return this.httpClient.post(endpoint, formData, {headers: headers});
// }

}
